/** fetch-worker - Buffern und Ausführen von Schreib-Befehlen an Backends
 *  - vormals benannt "BackendWorker"
 * 
 *  @param ENV_SETTINGS_JS.NS  - Namespacing, z.B. "kh-menue"
 * 
*/

import { Preferences } from "@capacitor/preferences";
import { dbQuery } from "@saint/sqlite-worker";

let bworkerBuffer = [] ;
let bworkerBufferError = [] ;
let bworkerBufferBusy = false;
let bworkerBufferIn = 0;
let bworkerBufferOut = 0;
let bworker_queue_insert_id ;
let bworker_last_entry_id = [ 'not-inited' ] ;
let bworker_queue_open_entries = [ 'not-inited' ] ;
let bworkerFailure = false;
let timer=0;

const login_reset_fallback = async () => {
 await Preferences.remove({key:ENV_SETTINGS_JS.NS + '.token'})
  window.location.reload()
}

const get_bworker_last_entry_id = () => {
  let qry =
    ` SELECT
        bworker_queue_id
      FROM
        system_bworker_queue
      ORDER BY
        bworker_queue_id DESC
      LIMIT 1
    `
  ;
  dbQuery( qry , store_bworker_last_entry_id ) ;
}

const get_bworker_open_entries = () => {
  let qry =
    ` SELECT
        *
      FROM
        system_bworker_queue
      WHERE
        bworker_queue_sent IS NULL
    `
  ;
  dbQuery( qry , store_bworker_open_entries ) ;
}

export const store_bworker_last_entry_id = ( entry ) => {
  bworker_last_entry_id = entry ;
}

export const store_bworker_open_entries = ( entries ) => {
  bworker_queue_open_entries = entries ;
}

/** init_bworker - Initialisierung Backend-Worker
 *  - ! erst nach Initialisierung von jeep-sqlite ausführbar
 *  - ! erst nach Initialisierung SQLite-DB sinnvoll
 *  - => Aufruf via import in AppContext.tsx (dort schon useEffect auf DBInited
 *        für Betriebe-Liste
 * 
 *  @param  do_run  bool  nur bei "true" tatsächliche Ausführung => keine Ausführung durch reines React-Rendering
*/
export const init_bworker = async ( do_run ) =>
  {
    if( do_run ) {
      /** "Kontroll-Tabelle" system_bworker_queue anlegen wenn noch nicht / nicht mehr da */
        dbQuery(
          ` CREATE TABLE IF NOT EXISTS system_bworker_queue
            (
              bworker_queue_id INTEGER PRIMARY KEY NOT NULL ,
              bworker_queue_entry VARCHAR NOT NULL ,
              bworker_queue_created DATETIME NOT NULL ,
              bworker_queue_sent DATETIME
            );
          `
        ) ;
      let tries = 0 ;
      /** wg. Restart noch nicht abgearbeitete Einträge ermitteln */
        get_bworker_open_entries() ;
        tries = 0 ;
        while( bworker_queue_open_entries[ 0 ] === 'not-inited' && tries < 10 ) {
          await new Promise( r => setTimeout( r , 200 ) ) ;
        }
        if( bworker_queue_open_entries[ 0 ] === 'not-inited' ) {
          console.error( 'FEHLER: init_bworker: bworker_queue_open_entries' ) ;
        } else {
          Object.keys( bworker_queue_open_entries.values )
            .forEach(
              ( value , index ) => {
                let db_entry = bworker_queue_open_entries.values[ value ] ;
                let stored_bworkerArgs = JSON.parse( db_entry.bworker_queue_entry ) ;
                stored_bworkerArgs.handlers = { loginReset: login_reset_fallback }
                bworkerQuery( stored_bworkerArgs , db_entry.bworker_queue_id ) ;
              }
            )
        }
      /** ID-Start in system_bworker_queue für neue Einträge ermitteln
       *  - ! egal ob vorheriger Eintrag bereits abgearbeitet wurde oder nicht
       */
        get_bworker_last_entry_id() ;
        tries = 0 ;
        while( bworker_last_entry_id[ 0 ] === 'not-inited' && tries < 10 ) {
          await new Promise( r => setTimeout( r , 200 ) ) ;
        }
        if( bworker_last_entry_id[ 0 ] === 'not-inited' ) {
          console.error( 'FEHLER: init_bworker: get_bworker_last_entry_id' ) ;
        } else {
          if( bworker_last_entry_id.values.length !== 0 ) {
            // @ts-ignore
            bworker_queue_insert_id = bworker_last_entry_id.values[ 0 ].bworker_queue_id + 1 ;
          } else {
            bworker_queue_insert_id = 1 ;
          }
        }
      }
    }

const checkToken = async () => {
  const { value } = await Preferences.get({ key: ENV_SETTINGS_JS.NS + '.token' });
  if( !value ) {
    return '' ;
  }
  return value ;
};

const hash_url = ( url , hash ) =>
  {
    if( url.includes( '') ) {
      return url.replace( '?' , '?' + hash + '&' ) ;
    }
    if( url.slice( -1 ) === '/' ) {
      return url.replace( /.$/ , '?' + hash ) ;
    }
    return url += '?' + hash ;
  }

export function bworkerQuery( bworkerArgs , existing_entry_id ){
  let insert_id ;
  if( existing_entry_id === undefined ) {
    insert_id = bworker_queue_insert_id++ ;
    dbQuery(
      `INSERT INTO system_bworker_queue
        ( bworker_queue_id , bworker_queue_entry , bworker_queue_created )
       VALUES
        ( ` + insert_id + ` , '` + JSON.stringify( bworkerArgs ) + `' , '` + new Date().toISOString() + `' )
      `
    ) ;
    } else {
    insert_id = existing_entry_id ;
  }
  if( bworkerFailure ) {
    bworkerBufferBusy = false ;
    bworkerFailure = false ;
  }
  bworkerBufferIn++
  bworkerBuffer.push( [ insert_id , bworkerArgs ] )
  bworkerBufferWorker()
}

async function bworkerBufferWorker(){
  let myHeaders = new Headers();
  let myToken = await checkToken() ;
  myHeaders.append( 'Accept' , 'application/json' ) ;
  myHeaders.append( 'Authorization' , 'Bearer ' + myToken ) ;
  if(bworkerBufferBusy===false){
    if(bworkerBuffer.length>0){
      bworkerBufferBusy=true
      try {
          // let my_hash = window.crypto.randomUUID() ;
          // await fetch( hash_url( bworkerBuffer[0][1].url , my_hash ) )
          await fetch(
            bworkerBuffer[0][1].url ,
            {
              body: bworkerBuffer[0][1].data ,
              cache: 'no-store' ,
              headers: myHeaders ,
              method: bworkerBuffer[0][1].method ,
              mode: 'cors'
            }
          )
        .then((response) => 
        {
          switch (response.status){
            case 403: {
              console.warn('neuer login erforderlich')
              alert( 'Anmeldung abgelaufen für\n\n' + bworkerBuffer[0][1].url + '\n\n- bitte neu anmelden' ) ;
              bworkerBuffer[0][1].handlers.loginReset() ;
              timer =10000
              break;
            }
            case 200: {
              dbQuery(
                ` UPDATE
                    system_bworker_queue
                  SET
                    bworker_queue_sent = '` + new Date().toISOString() + `'
                  WHERE
                    bworker_queue_id = ` + bworkerBuffer[0][0] + `
                `
              ) ;
              // console.log( 'WRITE TO SQLITE: ENTRY' , bworkerBuffer[0][0] , 'SENT' ) ;
              bworkerBuffer.shift()
              timer =0
              bworkerBufferOut++
              break;
            }
            case 500: {
              console.error("server Fehler")
              break;
            }
            default: {
              console.error("sonstiger Fehler")
              timer =10000
            }
          }
        }
        
        
        )
       .catch((error) => {
        console.error('Netzwerk-Error:', error);
        timer =10000

      })
    } 
      catch (err) {
        bworkerFailure = true ;
        bworkerBufferError
          .push(
            [
              new Date().toLocaleString() ,
              err ,
             
            ]
          )
        console.error( 'bworkerBufferWorker Try/Catch-Fehler: ', err );
        console.error( 'Fehler bworkerBufferWorker: ', bworkerBufferError[ bworkerBufferError.length - 1 ] );
        console.info( 'Fehlerliste bworkerBufferWorker: ', bworkerBufferError );
      }
      finally {
        
          
          setTimeout( () => { 
            bworkerBufferBusy=false
            bworkerBufferWorker() 
          },timer) ;
          
        
      }
    }   
  }
}

export function exportBworkerBufferIn( action ){
  if( action === 'reset' ) {
    bworkerBufferIn = 0 ;
  }
  return bworkerBufferIn
}

export function exportBworkerBufferOut( action ){
  if( action === 'reset' ) {
    bworkerBufferOut = 0 ;
  }
  return bworkerBufferOut
}

export function exportBEBufferEmpty() {
  if(bworkerBuffer.length>0){
    return false
  }
  return true
}
